import FileUploaderField from '@/commons/components/Form/FileUploaderField';
import { IMAGE_TYPE_UPLOAD } from '@/commons/constants';
import { Dispatch, RootState } from '@/redux/store';
import { CommonFileType, FileModel } from '@/types';
import { Button, Col, Row } from 'antd';
import { FC, useCallback, useState } from 'react';
import { Accept } from 'react-dropzone';
import { useDispatch, useSelector } from 'react-redux';

type Props = {
  onUploadDone: (files: FileModel[]) => void;
  multiple?: boolean;
  accept?: Accept;
};

const UploadNewFiles: FC<Props> = (props: Props) => {
  const { onUploadDone, multiple = true, accept = IMAGE_TYPE_UPLOAD.accept } = props;
  const dispatch = useDispatch<Dispatch>();
  const loading = useSelector((state: RootState) => state.storage.loading);
  const [files, setFiles] = useState<CommonFileType[]>([]);

  const handleUpload = useCallback(() => {
    if (files.length) {
      dispatch.storage.uploadFiles(files).then((uploaded) => {
        setFiles([...files]);
        if (onUploadDone) {
          onUploadDone(uploaded);
        }
      });
    }
  }, [files]);

  return (
    <Row>
      <Col span={24}>
        <FileUploaderField
          placeholder="Add new files"
          value={files}
          onChange={setFiles}
          accept={accept}
          multiple={multiple}
        />
      </Col>
      <Col span={24} style={{ paddingTop: 5 }}>
        <Button loading={loading} type="primary" onClick={handleUpload}>
          Upload
        </Button>
      </Col>
    </Row>
  );
};

export default UploadNewFiles;
